import * as moment from 'moment';
import * as _ from 'lodash';
import { Checkbox, ControlLabel, Form, FormControl, FormGroup } from 'react-bootstrap';
import DateTimePicker from '@nkr/components/date-time-picker';
import { FormWrapper } from './styles';
import { FormEvent } from 'react';

interface IProps {
    iCal: boolean,
    startDate: string,
    startTime: string,
    endDate: string,
    endTime: string,
    requireRsvp: boolean,
    onChange: (iCal: boolean, startDate: string, startTime: string, endDate: string, endTime: string, requireRsvp: boolean) => void
}

const CalendarInvite = (props: IProps) => {
    const handleICalChange = () => {
        let { iCal, startDate, startTime, endDate, endTime, requireRsvp } = props;
        props.onChange(!iCal, startDate, startTime, endDate, endTime, requireRsvp);
    };

    const handleDateChange = (property: string, value: moment.Moment | string) => {
        if (property == 'startDate') {
            let v = typeof (value) == 'string' ? value : value.format('MM/DD/YYYY');
            props.onChange(iCal, v, props.startTime, props.endDate, props.endTime, props.requireRsvp);
        }

        if (property == 'endDate') {
            let v = typeof (value) == 'string' ? value : value.format('MM/DD/YYYY');
            props.onChange(iCal, props.startDate, props.startTime, v, props.endTime, props.requireRsvp);
        }
    };

    const handleTimeChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;

        if (name == 'startTime') {
            props.onChange(iCal, props.startDate, value, props.endDate, props.endTime, props.requireRsvp);
        }

        if (name == 'endTime') {
            props.onChange(iCal, props.startDate, props.startTime, props.endDate, value, props.requireRsvp);
        }
    };

    const handleRequireRsvpChange = () => {
        let { iCal, startDate, startTime, endDate, endTime, requireRsvp } = props;
        props.onChange(iCal, startDate, startTime, endDate, endTime, !requireRsvp);
    };

    const { iCal, startDate, startTime, endDate, endTime, requireRsvp } = props;

    const start = moment('2024-01-01 00:00:00');

    const times = _.range(0, 24 * 4).map(x => {
        let d = start.clone();
        d.add(x * 15, 'minute');

        return { value: d.format('HH:mm'), label: d.format('hh:mm A') };
    });

    return (
        <FormWrapper>
            <Form inline>
                <FormGroup>
                    <ControlLabel>Include iCal Meeting:</ControlLabel>
                    <Checkbox checked={iCal} onClick={handleICalChange} />
                </FormGroup>
            </Form>

            <Form inline>
                <FormGroup style={{ marginRight: 20 }}>
                    <ControlLabel>Start Date:</ControlLabel>
                    <DateTimePicker
                        useCloseButton={false}
                        includeStyle={false}
                        property={'startDate'}
                        dateFormat='MM/DD/YYYY'
                        showTime={false}
                        currentValue={startDate}
                        // borderColor={position.isPickupDateOutsideRange ? '#ff0000' : ''}
                        // borderWidth={position.isPickupDateOutsideRange ? 2 : 1}
                        onValueChanged={handleDateChange}
                    />
                </FormGroup>

                <FormGroup>
                    <ControlLabel>Start Time:</ControlLabel>
                    <FormControl
                        componentClass='select'
                        name='startTime'
                        value={startTime}
                        onChange={handleTimeChange}
                    >
                        {times.map((time, index) =>
                            <option key={'st-' + index} value={time.value}>{time.label}</option>
                        )}
                    </FormControl>
                </FormGroup>
            </Form>

            <Form inline>
                <FormGroup style={{ marginRight: 20 }}>
                    <ControlLabel>End Date:</ControlLabel>
                    <DateTimePicker
                        useCloseButton={false}
                        includeStyle={false}
                        property={'endDate'}
                        dateFormat='MM/DD/YYYY'
                        showTime={false}
                        currentValue={endDate}
                        // borderColor={position.isPickupDateOutsideRange ? '#ff0000' : ''}
                        // borderWidth={position.isPickupDateOutsideRange ? 2 : 1}
                        onValueChanged={handleDateChange}
                    />
                </FormGroup>

                <FormGroup>
                    <ControlLabel>End Time:</ControlLabel>
                    <FormControl
                        componentClass='select'
                        name='endTime'
                        value={endTime}
                        onChange={handleTimeChange}
                    >
                        {times.map((time, index) =>
                            <option key={'st-' + index} value={time.value}>{time.label}</option>
                        )}
                    </FormControl>
                </FormGroup>
            </Form>

            <Form inline>
                <FormGroup>
                    <ControlLabel>Require RSVP:</ControlLabel>
                    <Checkbox checked={requireRsvp} onClick={handleRequireRsvpChange} />
                </FormGroup>
            </Form >
        </FormWrapper>
    );
}

export default CalendarInvite;